import { QueryClient } from '@tanstack/react-query';

/** The console's single query cache, shared by the React tree and the route guards. */
export const queryClient = new QueryClient();
